<template>
    <div>
        <BasicDialog @close="closeClicked">
            <div class="title">Report Offer</div>
            <v-radio-group v-model="selectedReason">
                <v-radio v-for="(reason, index) in ReportOfferReasons" :key="index" :label="reason.description"
                    :value="reason.reasonCode"></v-radio>
            </v-radio-group>
            <div class="d-flex justify-center align-center">
                <v-btn rounded="pill" color="primary" class="text-none" @click="sendClicked">Send</v-btn>
            </div>
        </BasicDialog>
    </div>
</template>



<script setup lang="ts">

import { ref, inject, provide } from 'vue';
import { Ref } from 'vue';

import { OfferStore } from '@/store/offerStore';
import { useSnackbar } from '@/composables/useSnackbar';

import BasicDialog from '@/components/Common/Basic-Dialog.vue';
import { ReportOfferReasons } from '@/constants/ReportOfferReasons';



const emit = defineEmits(['close']);

const { showSnackbar } = useSnackbar();
const offerStore = OfferStore();

let openDialog = inject('reportOfferDialogOpen');
provide('openDialog', openDialog);

const selectedReason = ref(''); // This will hold the ID of the selected reason

const closeClicked = () => {
    (openDialog as Ref<boolean>).value = false;
    emit('close');
};

const sendClicked = async () => {
    try {
        await offerStore.reportSelectedOffer(selectedReason.value);
        showSnackbar({
            message: 'Offer Reported.',
            color: 'info'
        });
        closeClicked();
    } catch (error) {
        showSnackbar({
            message: 'Failed to report offer.',
            color: 'error'
        });
    }
};

</script>



<style scoped lang="scss">

.title {
    font-size: 24px;
    font-weight: bold;
}

</style>
